module.exports = [{
      plugin: require('../../../website_templates/5a0ae80c-f808-428d-acc6-3183c3e2ddca/node_modules/gatsby-theme-blocks/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../website_templates/5a0ae80c-f808-428d-acc6-3183c3e2ddca/node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"locale","languages":["es-BO"],"defaultLanguage":"es-BO","siteUrl":"https://test.gatsbyjs.io/","i18nextOptions":{"interpolation":{"escapeValue":false},"keySeparator":false,"nsSeparator":false},"pages":[{"matchPath":"/:lang?/products/:uid"},{"matchPath":"/:lang?/catalogs/:uid"},{"matchPath":"/preview","languages":["en"]}]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../website_templates/5a0ae80c-f808-428d-acc6-3183c3e2ddca/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
